export default "__VITE_ASSET__30355da4__"